import { render, staticRenderFns } from "./CheckboxInput.vue?vue&type=template&id=678acd54&scoped=true&"
import script from "./CheckboxInput.vue?vue&type=script&lang=js&"
export * from "./CheckboxInput.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxInput.vue?vue&type=style&index=0&id=678acd54&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678acd54",
  null
  
)

export default component.exports